module.exports = __webpack_public_path__ + "static/media/Frame-piece-collection.fbabc49b.png";